import { Button, Modal, Space, Text, useModal } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from 'react-use'

import { getImgPath } from '../../../../src/utils/getImgPath'
import { LocalStorageKeys } from '../../../enums/localStorageKeys'
import { ModalId } from '../../../enums/modalId'
import { useOrganizationBrand } from '../../../hooks/useOrganizationBrand'
import * as Styled from './styles'

export const MobileSignupWelcomeModal = (): ReactElement => {
  const { t } = useTranslation()
  const [, setIsClosedMobileExperienceMessage] = useLocalStorage(LocalStorageKeys.MobileExperienceMessageClosed)
  const { isBrandBilly } = useOrganizationBrand()
  const { close } = useModal(ModalId.MobileSignupWelcomeModal, {
    onClose: () => setIsClosedMobileExperienceMessage(true),
  })

  const handleCloseClick = useCallback(() => {
    close()
  }, [close])

  const goToDownloadApp = useCallback((link: string) => {
    window.location.replace(link)
  }, [])

  return (
    <Modal id={ModalId.MobileSignupWelcomeModal} size="s" closable>
      <Modal.Header />
      <Modal.Body>
        <Text alignment="center" weight="regular" variant="display">
          {t('signup.mobile.welcome_modal.title')}
        </Text>
        <Space size="s24" />
        <Text colorVariant="secondary" alignment="center" variant="bodyLG">
          {t('signup.billy.mobile.welcome_modal.sub_title')}
        </Text>
        <Space size="s24" />
        <Text alignment="center" weight="medium" variant="h4">
          {t('signup.mobile.welcome_modal.bold_section')}
        </Text>
        <Space size="s16" />
        <Styled.AppOptionsContainer>
          <Styled.AppIllustration
            onClick={() => goToDownloadApp(t(isBrandBilly ? 'google_play.billy.url' : 'google_play.zervant.url'))}
            src={getImgPath('/app-store-illustrations/billy-google-play.svg')}
            alt="Billy app"
          />
          <Styled.AppIllustration
            onClick={() => goToDownloadApp(t(isBrandBilly ? 'app_store.billy.url' : 'app_store.zervant.url'))}
            src={getImgPath('/app-store-illustrations/billy-app-store.svg')}
            alt="Billy app"
          />
        </Styled.AppOptionsContainer>
        <Button onClick={handleCloseClick} variant="outlined" fullWidth>
          {t('signup.mobile.welcome_modal.cta')}
        </Button>
      </Modal.Body>
    </Modal>
  )
}
